import handleError from '../core/utils/handleError';
import widgetStyleDetection from '../logical-components/widgetStyleDetection';
var sectionValidation = function (dom, freshConfig) {
    var _a;
    //
    // Feature toggles
    //
    // If the powered by is not toggled off
    if (!((_a = freshConfig === null || freshConfig === void 0 ? void 0 : freshConfig.options) === null || _a === void 0 ? void 0 : _a.hidePoweredBy)) {
        freshConfig.layout.push({
            type: 'poweredBy',
        });
    }
    // If the search is disabled
    if (dom.dataset['searchShow'] === 'false') {
        freshConfig.layout = freshConfig.layout.filter(function (section) { return section.type !== 'search'; });
    }
    // Overlay
    var overlaySection = freshConfig.layout.filter(function (item) { return item.type === 'overlay'; })[0];
    var sections = freshConfig.layout.filter(function (item) { return item.type !== 'overlay'; });
    // Make sure overlay is last, or always added
    if (overlaySection) {
        sections.push(overlaySection);
    }
    else {
        sections.push({
            type: 'overlay',
            options: {},
            hooks: {},
            views: {},
        });
    }
    return sections;
};
var renderSections = function (dom, config, sections) {
    var updatedSections = sectionValidation(dom, config);
    updatedSections.forEach(function (section) {
        var _a, _b;
        if (sections[section.type] &&
            typeof sections[section.type] === 'function' &&
            !((_a = section === null || section === void 0 ? void 0 : section.options) === null || _a === void 0 ? void 0 : _a.noDirectRender)) {
            var sectionFnc = sections[section.type];
            dom.appendChild(sectionFnc({
                section: section,
                config: config,
            }));
        }
        else {
            if ((_b = section === null || section === void 0 ? void 0 : section.options) === null || _b === void 0 ? void 0 : _b.noDirectRender) {
                return;
            }
            handleError({
                section: 'renderSection',
                message: "Mensenlinq - ".concat(section.type, " is not a valid section type for this widget"),
            });
        }
    });
    setTimeout(function () {
        var rememberMeSection = dom.querySelector('._mnslq-rememberMe-element');
        if (rememberMeSection) {
            widgetStyleDetection(rememberMeSection, config);
        }
    }, 250);
};
export default renderSections;
